import React from 'react';


// import useStyles from './useStyles';

import { Button, DialogTitle, DialogContent, DialogActions, Dialog, IconButton } from '@mui/material'
// import Button from '@mui/material/Button';
// import DialogTitle from '@mui/material/DialogTitle';
// import DialogContent from '@mui/material/DialogContent';
// import DialogActions from '@mui/material/DialogActions';
// import Dialog from '@mui/material/Dialog';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';

import SaveStatus from '../SaveStatus';





function ModalDeleteConfirm(props) {
  const {
    onClose,
    update = () => { },
    okText = "Удалить",
    okColor = "error",
    cancelText = 'Отмена',
    saver = () => { },
    progressObj,
    okIcon=<DeleteIcon/>,
    title = "Подтвердите удаление",
    open,

    // ...other
  } = props;


  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    saver()
    // onClose();
  };
  const postSave = () => {
    update()
    onClose()
  }


  return (
    <Dialog
      sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: "80%" } }}
      maxWidth="xs"
      open={open}
    >
      <DialogTitle>{title}</DialogTitle>
      <IconButton
        onClick={handleCancel}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent >
        <SaveStatus dataObj={progressObj} successShowTime={500} errShowTime={6000} postSuccessAction={postSave} />
        
      </DialogContent>
      <DialogActions>
        <Button onClick={handleOk} variant="contained" color={okColor} startIcon={okIcon}>
          {okText}
        </Button>
        <Button onClick={handleCancel} variant="outlined" color="primary">
          {cancelText}
        </Button>
      </DialogActions>
    </Dialog>

  );
}



export default ModalDeleteConfirm;
